<template>
    <div>
        <apexchart type="scatter" height="300" width="100%" :options="chartOptions" :series="series" />
    </div>
</template>

<script>
import VueApexCharts from "vue-apexcharts";
import { baseOptions, rgba } from "./theme";
import { moneyCompact, isNum } from "@/utils/format";

// Revenue figures here arrive in raw USD.
const money = (v) => (isNum(v) ? moneyCompact(v, 1) : "—");

export default {
    name: "RoundingChart",
    components: { apexchart: VueApexCharts },
    props: {
        renderingData: { type: Array, default: () => [] },
        renderingYear: { type: Array, default: () => [] },
    },
    computed: {
        series() {
            return this.renderingData;
        },
        chartOptions() {
            const base = baseOptions();
            return {
                ...base,
                chart: { ...base.chart, type: "scatter" },
                colors: ["#00AA6F", "#94A3B8"],
                markers: { size: 8, strokeWidth: 0, hover: { sizeOffset: 2 } },
                xaxis: {
                    categories: this.renderingYear,
                    tickPlacement: "between",
                    axisTicks: { show: false },
                    axisBorder: { color: rgba("line") },
                    labels: { style: { fontSize: "11px" } },
                    tooltip: { enabled: false },
                },
                yaxis: { opposite: true, labels: { formatter: money } },
                tooltip: { ...base.tooltip, shared: true, intersect: false, y: { formatter: money } },
            };
        },
    },
};
</script>
